import user from "./user";
import order from "./order";
import activity from "./activity";
import webview from "./webview";

export default [...user, ...order, ...activity,...webview];
